import React, { Component } from 'react';
import uuid from 'uuid';
import animateScrollTo from 'animated-scroll-to';
import styles from './withCustomScrollbar.scss';

const withScroll = (options = {}) => WrappedComponent => {
  return class extends Component {
    state = {
      visible: options.visible ? true : false,
      key: options.key || uuid(),
    };

    scrollElement = {};
    barDetail = {};
    timer = null;
    scrollTop = 0;
    scrollLeft = 0;
    scrollAFKey = null;
    dragging = false;

    resizeTimeout = null;

    generateRefName = (type, key) => {
      return (pre = '', after = '') => {
        return `${pre && pre + '-'}${type}${after && '-' + after}-${key}`;
      };
    };

    barElementSelecter = type => {
      if (!type) return alert('barElementSelecter 에는 type 값이 필수입니다.');
      const scrollbarRefName = this.generateRefName(
        'scroll-bar',
        this.state.key,
      );
      let obj = {};
      obj.barwrap = this.refs[scrollbarRefName(type, 'wrap')];
      obj.bar = this.refs[scrollbarRefName(type)];
      this.scrollElement[type] = obj;
    };

    componentDidMount() {
      const { key, visible } = this.state;
      this.scrollElement.section = this.refs[`scroll-section-${key}`];
      this.scrollElement.wrap = this.refs[`scroll-wrap-${key}`];
      this.scrollElement.content = this.refs[`scroll-content-${key}`];
      this.barElementSelecter('vertical');
      this.barElementSelecter('horizontal');

      const { section } = this.scrollElement;
      if (visible) {
        section.classList.add('active');
      }

      this.setPosition();
      this.addEvent();
      window.addEventListener('resize', this.handleResize);
    }

    componentDidUpdate() {
      this.setPosition();
    }

    componentWillUnmount() {
      this.removeEvent();
    }

    handleResize = e => {
      this.setState({});
    };

    addEvent = () => {
      return this.eventFactory('add')();
    };
    removeEvent = () => {
      return this.eventFactory('remove')();
    };
    eventFactory = (type = 'add') => {
      const { section, wrap, vertical, horizontal } = this.scrollElement;
      const direction = { v: 'vertical', h: 'horizontal' };
      const delay = 1500;

      return () => {
        vertical.bar[`${type}EventListener`]('mousedown', e => {
          e.stopPropagation();
          this.onMouseStart(e, direction.v);
        });
        horizontal.bar[`${type}EventListener`]('mousedown', e => {
          e.stopPropagation();
          this.onMouseStart(e, direction.h);
        });
        vertical.barwrap[`${type}EventListener`]('mousedown', e => {
          e.stopPropagation();
          this.onMouseDownBarWrap(e, direction.v);
        });
        horizontal.barwrap[`${type}EventListener`]('mousedown', e => {
          e.stopPropagation();
          this.onMouseDownBarWrap(e, direction.h);
        });
        document[`${type}EventListener`]('mousemove', this.onMouseMove);
        document[`${type}EventListener`]('mouseleave', this.onMouseUp);
        document[`${type}EventListener`]('mouseup', this.onMouseUp);

        vertical.bar[`${type}EventListener`]('touchstart', e => {
          e.stopPropagation();
          this.onMouseStart(e, direction.v);
        });
        horizontal.bar[`${type}EventListener`]('touchstart', e => {
          e.stopPropagation();
          this.onMouseStart(e, direction.h);
        });
        vertical.barwrap[`${type}EventListener`]('touchstart', e => {
          e.stopPropagation();
          this.onMouseDownBarWrap(e, direction.v);
        });
        horizontal.barwrap[`${type}EventListener`]('touchstart', e => {
          e.stopPropagation();
          this.onMouseDownBarWrap(e, direction.h);
        });
        document[`${type}EventListener`]('touchmove', this.onMouseMove);
        document[`${type}EventListener`]('touchend', this.onMouseUp);
        document[`${type}EventListener`]('touchcancel', this.onMouseUp);

        wrap[`${type}EventListener`]('scroll', e => {
          // e.stopPropagation();
          // console.log({ wrap, e });
          this.scrollTop = wrap.scrollTop;
          this.scrollLeft = wrap.scrollLeft;

          this.setPosition();
          if (this.state.visible) return;

          section.classList.add('active');
          if (this.timer) {
            clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
            section.classList.remove('active');
          }, delay);
        });
      };
    };

    onMouseDownBarWrap = (e, type = 'vertical') => {
      if (!type) return;
      // console.log(`onMouseDownBarWrap`, e);
      const status = this.dragBaseData(e, type);
      this.moveToScrollBar(e, status, type);
      this.setPosition();
    };

    moveToScrollBar = (e, status, type = 'vertical') => {
      const isTouch = e.type.match(/touch/g) ? true : false;
      let event = e;
      if (isTouch) event = e.touches[0];
      const { wrap } = this.scrollElement;
      const { option, ratio, scrollDistance } = status;
      const clientPosition = event[`client${option.coordinate}`];
      const offsetDistance = wrap[`offset${option.widthHeight}`];
      const eventClientRect = event.target.getBoundingClientRect();
      const distance =
        (clientPosition - eventClientRect[option.topLeft]) * ratio;
      const max = scrollDistance - offsetDistance;
      const scrollDirection = `scroll${option.topLeftCapitalize}`;
      this[scrollDirection] = distance;
      if (this[scrollDirection] <= 0) this[scrollDirection] = 0;
      if (this[scrollDirection] > max) this[scrollDirection] = max;

      wrap[scrollDirection] = this[scrollDirection];
      // const animateOption = { element: wrap };
      // animateScrollTo(this[scrollDirection], animateOption);
    };

    onMouseStart = (e, type = 'vertical') => {
      e.stopPropagation();
      e.preventDefault();
      this.drag = {};
      this.drag.type = type; // vertical, horizontal
      this.dragging = true;
      this.scrollElement.wrap.classList.add('scroll-true');
      this.drag.status = this.dragBaseData(e, type);
    };

    onMouseMove = async e => {
      if (!this.dragging || !this.drag.type) return;
      e.preventDefault();
      const { type, status } = this.drag;
      this.moveScrollBar(e, status, type);

      await this.setPosition();
    };

    capitalize = text => {
      if (typeof text !== 'string') return;
      let transition = text.split('');
      transition[0] = transition[0].toUpperCase();
      const capitalization = transition.join('');
      return capitalization;
    };

    dragBaseData = (e, type = 'vertical') => {
      const isTouch = e.type.match(/touch/g) ? true : false;
      let event = e;
      if (isTouch) event = e.touches[0];

      const { content, vertical, horizontal } = this.scrollElement;
      const status = {};
      const typeEl = type === 'vertical' ? vertical : horizontal;
      const barwrapClient = typeEl.barwrap.getBoundingClientRect();
      const coordinate = type === 'vertical' ? 'Y' : 'X';
      const topLeft = coordinate === 'Y' ? 'top' : 'left';
      const topLeftCapitalize = this.capitalize(topLeft);
      const widthHeight = coordinate === 'Y' ? 'Height' : 'Width';

      status.option = {
        typeEl,
        barwrapClient,
        coordinate,
        topLeft,
        topLeftCapitalize,
        widthHeight,
      };

      status[`barwrapPosition`] = barwrapClient[topLeft];
      status[`scrollDistance`] = content[`scroll${widthHeight}`];
      status[`barwrapDistance`] = typeEl.barwrap[`offset${widthHeight}`];
      status[`ratio`] = status[`scrollDistance`] / status[`barwrapDistance`];

      status[`basePosition`] = event[`client${coordinate}`];
      status[`baseScrollPosition`] =
        -this[`scroll${topLeftCapitalize}`] / status.ratio;

      return status;
    };

    moveScrollBar = (e, status, type = 'vertical') => {
      const isTouch = e.type.match(/touch/g) ? true : false;
      let event = e;
      if (isTouch) event = e.touches[0];
      const { wrap } = this.scrollElement;
      const {
        option,
        basePosition,
        baseScrollPosition,
        ratio,
        scrollDistance,
      } = status;

      const clientPosition = event[`client${option.coordinate}`];
      const offsetDistance = wrap[`offset${option.widthHeight}`];
      const distance =
        (clientPosition - basePosition - baseScrollPosition) * ratio;
      const max = scrollDistance - offsetDistance;
      const scrollDirection = `scroll${option.topLeftCapitalize}`;
      this[scrollDirection] = distance;
      if (this[scrollDirection] <= 0) this[scrollDirection] = 0;
      if (this[scrollDirection] > max) this[scrollDirection] = max;

      wrap[scrollDirection] = this[scrollDirection];
    };

    onMouseUp = e => {
      if (!this.dragging) return;
      const { wrap } = this.scrollElement;
      wrap.classList.remove('scroll-true');
      this.drag.status = {};
      this.dragging = false;
    };

    setPosition = () => {
      const { wrap, content, vertical, horizontal } = this.scrollElement;
      // console.log('3. ', { scrollTop: this.scrollTop });
      this.barDetail.vertical = {};
      this.barDetail.vertical.scrollHeight = content.offsetHeight;
      this.barDetail.vertical.scrollTop = this.scrollTop;
      this.barDetail.vertical.height = wrap.offsetHeight;
      this.barDetail.vertical.ratio =
        this.barDetail.vertical.scrollHeight / this.barDetail.vertical.height;
      this.barDetail.vertical.barHeight =
        this.barDetail.vertical.height / this.barDetail.vertical.ratio;
      this.barDetail.vertical.barPosition =
        this.barDetail.vertical.height /
        (this.barDetail.vertical.scrollHeight /
          this.barDetail.vertical.scrollTop);

      this.barDetail.horizontal = {};
      this.barDetail.horizontal.scrollWidth = content.scrollWidth;
      this.barDetail.horizontal.scrollLeft = this.scrollLeft;
      this.barDetail.horizontal.width = wrap.offsetWidth;

      this.barDetail.horizontal.ratio =
        this.barDetail.horizontal.scrollWidth / this.barDetail.horizontal.width;
      this.barDetail.horizontal.barWidth =
        this.barDetail.horizontal.width / this.barDetail.horizontal.ratio;
      this.barDetail.horizontal.barPosition =
        this.barDetail.horizontal.width /
        (this.barDetail.horizontal.scrollWidth /
          this.barDetail.horizontal.scrollLeft);

      // const { height, barHeight, barPosition } = this.barDetail;
      const verticalBar = this.barDetail.vertical;
      const horizontalBar = this.barDetail.horizontal;

      vertical.bar.style.height = verticalBar.barHeight + 'px';
      vertical.bar.style.top = verticalBar.barPosition + 'px';

      horizontal.bar.style.width = horizontalBar.barWidth + 'px';
      horizontal.bar.style.left = horizontalBar.barPosition + 'px';

      if (verticalBar.barHeight >= verticalBar.height) {
        vertical.barwrap.style.display = 'none';
      } else {
        // console.log(verticalBar, verticalBar.height);
        vertical.barwrap.style.display = 'block';
      }

      if (horizontalBar.barWidth >= horizontalBar.width) {
        horizontal.barwrap.style.display = 'none';
      } else {
        horizontal.barwrap.style.display = 'block';
      }
    };

    // shouldComponentUpdate(nextProps, nextState) {
    //   const props = {
    //     this: JSON.stringify(this.props),
    //     next: JSON.stringify(nextProps),
    //   };
    //   return props.this !== props.next;
    // }

    handleScrollTo = async ({ top = 0, left = 0 }, doesntHaveScroll) => {
      const { wrap } = this.scrollElement;
      this.scrollTop = top < 0 ? -top : top;
      // console.log(`2. Test : `, this.scrollTop);
      animateScrollTo(top, { elementToScroll: wrap });
      // this.setPosition();
    };

    render() {
      const { key, visible } = this.state;
      let {
        color = '#ddd',
        width = '10px',
        radius = '25px',
        right = '0px',
      } = this.props;

      if (typeof width === 'number') width = width + 'px';
      if (typeof right === 'number') right = right + 'px';

      let verticalStyle = {
        barWrap: { width, right },
        bar: { backgroundColor: color, borderRadius: radius },
      };

      let horizontalStyle = {
        barWrap: { height: width },
        bar: { backgroundColor: color, borderRadius: radius },
      };

      if (this.props.backgroundColor) {
        verticalStyle.barWrap.backgroundColor = this.props.backgroundColor;
        horizontalStyle.barWrap.backgroundColor = this.props.backgroundColor;
      }
      if (typeof this.props.padding === 'number') {
        verticalStyle.bar.height = `calc(100% - ${this.props.padding + 'px'})`;
        horizontalStyle.bar.height = `calc(100% - ${this.props.padding +
          'px'})`;
        verticalStyle.bar.bottom = `${this.props.padding / 2}px`;
        horizontalStyle.bar.bottom = `${this.props.padding / 2}px`;
      }

      if (visible) {
      }

      const scroll = {
        state: this.state,
        handle: {
          setPosition: this.setPosition,
          scrollTo: this.handleScrollTo,
        },
        el: this.scrollElement,
        ber: this.barDetail,
      };

      const sectionStyle = {};
      if (this.props.style) {
        const styleKeys = Object.keys(this.props.style);
        styleKeys.forEach(key => {
          sectionStyle[key] = this.props.style[key];
        });
      }

      return (
        <section
          className={styles['scroll-section']}
          ref={`scroll-section-${key}`}
          style={sectionStyle}
        >
          <div className={`scroll-wrap`} ref={`scroll-wrap-${key}`}>
            <div className="scroll-content" ref={`scroll-content-${key}`}>
              {/* {this.props.children} */}
              <WrappedComponent {...this.props} scroll={scroll} />
            </div>
          </div>

          <div
            className="scroll-bar-wrap vertical"
            ref={`vertical-scroll-bar-wrap-${key}`}
            style={verticalStyle.barWrap}
          >
            <span
              className="scroll-bar"
              ref={`vertical-scroll-bar-${key}`}
              style={verticalStyle.bar}
            />
          </div>

          <div
            className="scroll-bar-wrap horizontal"
            ref={`horizontal-scroll-bar-wrap-${key}`}
            style={horizontalStyle.barWrap}
          >
            <span
              className="scroll-bar"
              ref={`horizontal-scroll-bar-${key}`}
              style={horizontalStyle.bar}
            />
          </div>
        </section>
      );
    }
  };
};

export default withScroll;
